module.exports = __webpack_public_path__ + "static/media/GooglePlayBadge.db9b21a1.png";